import { render, staticRenderFns } from "./ErrorsAlert.vue?vue&type=template&id=72123d54&"
import script from "./ErrorsAlert.vue?vue&type=script&lang=js&"
export * from "./ErrorsAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports